import React, { Component } from "react";
import {
  // TextField,
  // InputAdornment,
  // MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@material-ui/core";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactTableComponent from "../../ReactTable/ReactTable";
import { emailTemplatesList, emailTemplateQuery } from "./EmailTemplatesConfig";

// import SearchIcon from "@material-ui/icons/Search";
import { fetchMethod, debounce } from "../../FetchMethod";
import { connect } from "react-redux";
import "./../Sites/sites.css";
import store from "../../Redux/Store";
import { FadeLoader } from "react-spinners";
// import { mutationQueries } from "../../MutationMethod";
import EditIcon from "./../../DumbAssets/EditIcon";

class EmailTemplatesTable extends Component {
  state = {
    pageNo: parseInt(localStorage.getItem("rows")),
    rows: parseInt(localStorage.getItem("rows")),
    listData: undefined,
    count: 0,
    isAscSort: true,
    StatusData: [
      {
        id: "PENDINGCONDITIONALAPPROVED",
        name: "Pending Conditional Approved",
      },
      { id: "CONDITIONALLYAPPROVED", name: "Conditionally Approved" },
      { id: "APPROVEDTOTREAT", name: "Approved to Treat" },
      { id: "INDEPENDENT", name: "Independent" },
    ],
    filter: { active: 1 },
    countryData: undefined,
    countryid: null,
    cityid: null,
    cityData: undefined,
    salesRepData: undefined,
    deletemodalOpen: false,
    approvalstatus: "",
    search: "",
    isRolePermission: store.getState().Permission
      ? store.getState().Permission.USER_SITE_FILE_PERMISSION
      : false,
    loading: true,
    deleteid: 0,
  };

  UNSAFE_componentWillMount() {
    this.setState({ listData: [] });
    this.props.sideBarPath("/email-templates");
    this.getlistData();
  }
  getlistData = () => {
    fetchMethod(emailTemplateQuery, {
      where: this.state.filter,
      last: this.state.rows,
      first: this.state.pageNo,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }

        if (res.data.allEmailtemplates.Emailtemplates) {
          let data = res.data.allEmailtemplates.Emailtemplates;

          this.setState({
            listData: data,
            loading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
  };

  debounceTimer = null;
  handleSearch = (e) => {
    const {
      target: { name, value },
    } = e;
    let { filter } = this.state;
    filter["and"] = [
      {
        or: [
          { siteid: { like: `%${value}%` } },
          { name: { like: `%${value}%` } },
        ],
      },
    ];
    this.setState({ [name]: value, filter, pageNo: this.state.rows }, () => {
      this.debounceTimer = debounce(
        this.debounceTimer,
        () => {
          this.getlistData();
        },
        200
      );
    });
  };
  handleSelect = (e) => {
    const {
      target: { name, value },
    } = e;
    let { filter } = this.state;
    filter[name] = value;
    this.setState({ [name]: value, filter }, () => this.getlistData());
  };
  handleSearchSelect = (name, value) => {
    let { filter } = this.state;
    filter[name] = value.id;
    this.setState({ [name]: value, filter }, () => this.getlistData());
  };
  sortByHeader = (item) => {
    if (item === "kind") {
      const { filter } = this.state;

      let { sortingParam, isAscSort } = this.state;

      if (this.state.isAscSort) {
        filter["order"] = "kind DESC";
        sortingParam = "kind";
        isAscSort = false;
      } else {
        sortingParam = item;
        filter["order"] = "kind ASC";
        isAscSort = true;
      }

      this.setState(
        {
          filter,
          sortingParam,
          isAscSort,
        },
        () => this.getlistData()
      );
    }
  };

  editForm = (id, kind,name,subject,message) => {
    this.props.history.push({
      pathname: "EmailTemps",
      state: { id: id, kind: kind, subject: subject,name:name, message: message },
    });
  };
  clearFilter = () => {
    this.setState(
      {
        search: "",
        approvalstatus: "",
        countryid: null,
        cityid: null,
        filter: { active: 1 },
      },
      () => this.getlistData()
    );
  };
  render() {
    const nameAndImage = [
      {
        Header: "Template Number",
        accessor: "sNo",
        width: 120,
      },
      {
        Header: () => {
          return (
            <div style={{ cursor: "pointer" }}>
              Template Name
              {/* {this.state.isAscSort ? <ArrowUpward /> : <ArrowDownward />} */}
            </div>
          );
        },
        accessor: "name",
        sortable: false,
      },
    ];

    const actions = [
      {
        Header: "Action",
        sortable: false,
        width: 80,
        Cell: (row) => (
          <div style={{ marginLeft: "0px" }} className="actions">
            <IconButton
              className="editicon"
              onClick={() =>
                this.editForm(
                  row.original.id,
                  row.original.kind,
                  row.original.name,
                  row.original.subject,
                  row.original.message
                )
              }
            >
              <EditIcon />
            </IconButton>
          </div>
        ),
      },
    ];

    const columns = this.state.isRolePermission
      ? nameAndImage.concat(emailTemplatesList.columns).concat(actions)
      : nameAndImage.concat(emailTemplatesList.columns);
    return (
      <div className="Sites">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        <h1>Email Templates</h1>

        <div className="SitesTableSection">
          {this.state.listData ? (
            <ReactTableComponent
              listData={this.state.listData}
              listConfig={emailTemplatesList}
              columns={columns}
              dataCount={this.state.count}
              onHeaderClick={this.sortByHeader}
              updatePagination={this.updatePagination}
              initialPage={this.state.pageNo / this.state.rows}
              forSerialNo={{
                pageNo: this.state.pageNo,
                pageSize: this.state.rows,
              }}
            />
          ) : (
            ""
          )}
        </div>
        <Dialog
          open={this.state.deletemodalOpen}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} className="cancelbtn">
              Cancel
            </Button>
            <Button
              onClick={this.handleDelete}
              autoFocus
              className="confirmbtn"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    sideBarPath: (route) =>
      dispatch({ type: "Show_Sidebar_Route", payload: route }),
  };
};

export default connect(null, mapDispatchToProps)(EmailTemplatesTable);
